// zipファイル周りの処理をまとめたもの

import JSZip from 'jszip';
import Encoding from 'encoding-japanese';
import iconv from 'iconv-lite';
import { getExt } from '../fileUtil';

/**
 * zipファイルの解凍→ファイルオブジェクト[]を返す
 * @param zipFile zipファイル
 */
export const unzipForFile = async (zipFile: File): Promise<File[]> => {
  const output: File[] = [];
  const jsZip = await JSZip.loadAsync(zipFile, {
    // 文字コード変換処理
    // zip解凍されたフォルダ内のファイル名をバイナリデータにして、判定・変換を行う
    decodeFileName: function (fileNameBinary) {
      // ファイル名の文字コードの判定を行う
      const stringCode = Encoding.detect(fileNameBinary as Buffer);
      // fileNameBinaryが無い(Uint8Array[0]である)場合に空文字を返す
      if (!stringCode) return '';
      // それぞれの文字コードでデコードして返す
      return iconv.decode(fileNameBinary as Buffer, stringCode);
    },
  });

  const zipObjects: any[] = [];
  jsZip.forEach((relativePath, zipObject) => {
    // MAC_OSの余計なファイルを無視したい(TODO: Windowsも多分対応がいるはず)
    if (zipObject.name.indexOf('__MACOSX') > -1) {
      // 部分一致のときの処理
      return;
    }
    if (getExt(zipObject.name) !== 'xlsx') {
      // TODO: バリデートを実施
    }
    // ex {
    //     name: 'hoge.zip',
    //     dir: false,
    //     date: 2021-10-07T15:10:04.000Z,
    //     comment: null,
    //     unixPermissions: null,
    //     dosPermissions: 0,
    //     _data: {...},
    //     _dataBinary: true,
    //     options: { compression: null, compressionOptions: null }
    // }
    zipObjects.push(zipObject);
  });
  for (const zipObj of zipObjects) {
    const content = await zipObj.async('blob');
    const zipObjData: File = content as File; // 厳密にはname要素を持っていないので付け加える必要あり
    // 本来nameはread-onlyなので書き換えできないが以下の方法で「現状」何とかなるので無理やりセットしている
    Object.assign(zipObjData, { name: zipObj.name });
    output.push(zipObjData);
  }
  return output;
};
